<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('general.action_record') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/dashboard">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
        </li>
        <li class="breadcrumb-item">{{ $t('general.action_record') }}</li>
      </ol>
      <div class="page-actions row">
        <button v-if="invoiceType !='preapproved' && (userType == 'anchor' || userType == 'supplier') && invoiceStatus != 'DRAFT'" outline color="theme" class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size" @click="downloadExcelReport">
          {{ $t('general.alfalah_connect') }}
        </button>
        <a v-if="invoiceType !='preapproved'" :href="`/invoices/download_all_files/${invoiceUniqueHash}`" target="_blank" class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size" outline color="theme">
          {{ $t('general.download_all_files') }}
        </a>
        <a v-else-if="(invoiceType ==='preapproved' && userType==='super_admin')" :href="`/invoices/download_all_files/${invoiceUniqueHash}`" target="_blank" class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size" outline color="theme">
          {{ $t('general.download_all_files') }}
        </a>
        <a v-if="hasInvoiceAttachments && invoiceUniqueHash" :href="`/invoices/download_invoiceAttachment/${invoiceUniqueHash}`" target="_blank" class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size" outline color="theme">
          {{ $t('general.download_invoice_attachments') }}
        </a>
        <a v-if="hasPOAttachments=== true && invoiceUniqueHash" :href="`/invoices/download_poAttachment/${invoiceUniqueHash}`" target="_blank" class="mr-3 invoice-action-btn base-button btn btn-outline-primary default-size" outline color="theme">
          {{ $t('general.download_po_attachments') }}
        </a>
      </div>
    </div>
    <SinglePreapprovedInvoiceRow v-if="invoiceType==='preapproved'" :fetch-data="fetchData"/>
    <SingleInvoiceRow v-else :fetch-data="fetchData" />
    <table-component
      ref="table"
      :show-filter="false"
      :data="actionRecord"
      table-class="table"
    >
      <table-column
        :label="$t('invoices.date')"
        sort-as="invoice_date"
        show="formattedCreatedAt"
      />
      <table-column
        :label="$t('invoices.status')"
        sort-as="status"
      >
        <template slot-scope="row">
          <span> {{ $t('invoices.status') }}</span>
          <span v-if="userType=='anchor' && row.status=='SENT'" :class="'inv-status-'+row.status.toLowerCase()">{{ $t('general.received') }}</span>
          <span v-else-if="userType=='anchor' && row.status !='SENT'" :class="'inv-status-'+row.status.toLowerCase()">{{ (row.status != 'PARTIALLY_PAID')? row.status : row.status.replace('_', ' ') }}</span>
          <span v-else-if="userType!='anchor'" :class="'inv-status-'+row.status.toLowerCase()">{{ (row.status != 'PARTIALLY_PAID')? row.status : row.status.replace('_', ' ') }}</span>
        </template>
      </table-column>
      <table-column
        :label="$t('general.company_name')"
      >
        <template slot-scope="row">
          {{ row.company_name }}
        </template>
      </table-column>
    </table-component>
  </div>

</template>
<script>
import { mapActions } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import SingleInvoiceRow from './SingleInvoiceRow'
import SinglePreapprovedInvoiceRow from '../preapprovedInvoices/SingleInvoiceRow.vue'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import moment from 'moment'
export default {
  components: {
    MultiSelect,
    SingleInvoiceRow,
    SinglePreapprovedInvoiceRow
  },
  mixins: [validationMixin],
  data () {
    return {
      userType: null,
      fetchData: [],
      actionRecord: [],
      isLoading: false,
      invoiceUniqueHash: '',
      hasPOAttachments: false,
      hasInvoiceAttachments: false,
      invoiceType: null,
      invoiceStatus: null
    }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    }
    this.loadData()
    this.loadInvoice()
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('prepayment', [
      'fetchPrePaymentRequest',
      'fetchPrePayment'
    ]),
    ...mapActions('payment', [
      'fetchPaymentThroughInvoice'
    ]),
    formatDate (dateString, format = 'dd-MM-yyyy') {
      if (!dateString) return null
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return format
        .replace(/dd/g, day)
        .replace(/MM/g, month)
        .replace(/yyyy/g, year)
        .replace(/yy/g, String(year).slice(-2))
    },
    async downloadExcelReport () {
      try {
        this.isLoading = true

        // Call the API to get invoice details
        const response = await window.axios.get(`/api/invoices/download-alfalah-connect/${this.invoiceUniqueHash}`)

        if (!response.data.result || !response.data.data) {
          window.toastr['error']('Failed to fetch invoice data')
          return
        }

        const invoice = response.data.data.invoice
        const cifBuyer = response.data.data.cif_buyer
        const cifSeller = response.data.data.cif_seller
        const programCode = response.data.data.program_code

        console.log('Invoice data:', invoice)
        console.log('Customer data:', invoice.customer)

        // Format invoice data with safe navigation
        const formattedInvoice = {
          Identified: 'I',
          invoiceNumber: invoice.reference_number || '',
          invoiceDate: invoice.invoice_date ? this.formatDate(invoice.invoice_date, 'dd-MM-yyyy') : '',
          invoiceDueDate: invoice.due_date ? this.formatDate(invoice.due_date, 'dd-MM-yyyy') : '',
          currency: (invoice.customer && invoice.customer.currency && invoice.customer.currency.code) || '',
          invoiceWithoutTaxAmount: invoice.sub_total || 0,
          cifBuyer: cifBuyer || '',
          cifSeller: cifSeller || '',
          buyerName: (
            invoice.customer && invoice.customer.parent_account && invoice.customer.parent_account.company_name) || '',
          sellerName: (invoice.company && invoice.company.name) || '',
          programCode: programCode || '',
          invoiceDiscountAmount: invoice.discount || 0,
          invoiceTaxAmount: invoice.tax || 0,
          totalAmountToFinance: invoice.total || 0,
          acceptance: 'N'
        }

        // Get all column data in order
        const rowData = [
          formattedInvoice.Identified,
          formattedInvoice.invoiceNumber,
          formattedInvoice.invoiceDate,
          formattedInvoice.invoiceDueDate,
          formattedInvoice.currency,
          formattedInvoice.invoiceWithoutTaxAmount,
          formattedInvoice.cifBuyer,
          formattedInvoice.cifSeller,
          formattedInvoice.buyerName,
          formattedInvoice.sellerName,
          formattedInvoice.programCode,
          formattedInvoice.invoiceDiscountAmount,
          formattedInvoice.invoiceTaxAmount,
          formattedInvoice.totalAmountToFinance,
          '',
          '',
          formattedInvoice.acceptance
        ]

        // Create worksheet without headers
        const worksheetData = [rowData]
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Details')

        // Generate Excel file
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        })
        const data = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        // Download file
        const fileName = `Invoice_${invoice.invoice_number || 'Details'}_${moment().format('YYYY-MM-DD')}.xlsx`
        saveAs(data, fileName)

        window.toastr['success']('Excel file downloaded successfully')
      } catch (error) {
        console.error('Error downloading Excel:', error)
        window.toastr['error']('Error downloading Excel file')
      } finally {
        this.isLoading = false
      }
    },
    async loadData () {},
    async loadInvoice () {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
      if (response.data) {
        this.invoiceUniqueHash = response.data.invoice[0]['unique_hash']
        this.invoiceStatus = response.data.invoice[0]['status']
        this.invoiceType = response.data.invoice[0]['invoice_type']
        if (response.data.invoice[0]['media'].length > 0) {
          this.hasInvoiceAttachments = true
        }
        if (response.data.invoice[0]['delivery_note'] && response.data.invoice[0]['delivery_note']['purchase_order']['media'].length > 0) {
          this.hasPOAttachments = true
        }
        this.fetchData = response.data.invoice
        this.actionRecord = response.data.invoiceAction
      }
    }

  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>
